import {useQuery} from "react-query"
import nprogress from "nprogress"
import swal from "sweetalert"
import useAuth from "auth/useAuth"
import {setLocalItem} from "utils/utils"

export default function useValues(category) {
    
    const {auth, API} = useAuth()
    const localStorageKey = `values-${category}`

    const fetched = (data) => {
        setLocalItem(localStorageKey, data)
    }
    
    const preload = () => {
        const data = localStorage.getItem(localStorageKey)
        if (!data) return {}
        return JSON.parse(data)
    }
    
    const query = useQuery(
        ["values", category],
        () => auth(API.valuesCategoryGet, {category}).then(response => response.data),
        {
            initialData: preload,
            onSuccess: fetched,
        }
    )
    
    const get = (key, def=null) => {
        if (key in query.data)
            return query.data[key]
        return def
    }
    
    const isEmpty = (key) => {
        if (!(key in query.data)) return true
        return !query.data[key]
    }
    
    const set = (key, value, onSuccess=null, onError=null) => {
        if (!onSuccess) nprogress.start()
        auth(API.valuesCategoryKeyPut, {category, key}, JSON.stringify(value)).then(response => {
            query.refetch()
            if (onSuccess) onSuccess(response.data)
            else nprogress.done()
        }).catch(response => {
            if (onError) onError(response.data)
            else {
                nprogress.done()
                swal('Error', 'Not saved', 'error')
            }
        })
    }
    
    return {...query, get, set, isEmpty}

}